export default __webpack_public_path__ + "static/media/Control-filled.0fcc2028.svg";